import React from "react";
import { Row, Col } from "react-bootstrap";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Assets
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import EditableDataTable from "../CustomUIComponents/EditableDataTable/EditableDataTable";
import UserModal from "../CustomUIComponents/UserModal/UserModal";

import addSubType from "../../resources/images/ic_add_subtype_bold.svg";

class CollectionExpenseConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataForTable: props.dataForTable,
      deleteConfirm: { show: false, index: null },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataForTable !== this.props.dataForTable) {
      this.setState({ dataForTable: this.props.dataForTable });
    }
  }

  handleCollectionTypeChange = (e, expenseIndex) => {
    const { configurationData, handleCollectionExpenseChange } =
      this.props;

    const expenseConfig =
      configurationData.configurationObject?.expenseConfig;

    const updatedFullData = expenseConfig.map((config, i) => {
      if (i !== expenseIndex) return config;
      return { ...config, expenseType: e.target.value };
    });

    handleCollectionExpenseChange(updatedFullData);
  };

  handleRowChange = (dataRow, expenseIndex) => {
    const { configurationData, handleCollectionExpenseChange } =
      this.props;

    const expenseConfig =
      configurationData.configurationObject?.expenseConfig;

    const updatedFullData = expenseConfig.map((config, i) => {
      if (i !== expenseIndex) return config;
      return { ...config, amountRange: dataRow };
    });

    handleCollectionExpenseChange(updatedFullData);
  };

  requestDeleteAccordion = (e, expenseIndex) => {
    e.stopPropagation();
    this.setState({ deleteConfirm: { show: true, index: expenseIndex } });
  };

  confirmDeleteAccordion = () => {
    const { configurationData, handleCollectionExpenseChange } = this.props;
    const { index } = this.state.deleteConfirm;

    const expenseConfig =
      configurationData.configurationObject?.expenseConfig;

    const updatedFullData = expenseConfig.filter((_, i) => i !== index);

    this.setState({ deleteConfirm: { show: false, index: null } });
    handleCollectionExpenseChange(updatedFullData);
  };

  cancelDeleteAccordion = () => {
    this.setState({ deleteConfirm: { show: false, index: null } });
  };

  handleAddNew = () => {
    const { configurationData, handleCollectionExpenseChange } =
      this.props;

    const expenseConfig =
      configurationData.configurationObject?.expenseConfig;

    const updatedFullData = [
      ...expenseConfig,
      { expenseType: "", amountRange: [], new: true },
    ];

    handleCollectionExpenseChange(updatedFullData, true);
  };

  render() {
    const { props, state } = this;
    const expenseConfig =
      props.configurationData.configurationObject?.expenseConfig;
    const errors = props.errors || {};

    return (
      <div className='emiConfiguration pb-10 mr-10'>
        {state.deleteConfirm.show && (
          <UserModal
            open={state.deleteConfirm.show}
            modalCloseOnEsc={false}
            modalCloseOnOverlayClick={false}
            modalShowCloseIcon={false}
            headerText={Strings("Delete")}
            modalText1={Strings("DeleteExpenseType")}
            modalButtonOk={{
              text: Strings("Delete"),
              onClick: this.confirmDeleteAccordion,
            }}
            modalButtonCancel={{
              text: Strings("Cancel"),
              onClick: this.cancelDeleteAccordion,
            }}
            showHr={true}
          />
        )}

        {expenseConfig.map((expense, expenseIndex) => {
          const accordionError = errors[expenseIndex];
          const hasAccordionError = !!accordionError;
          return (
            <Row key={"key-" + expenseIndex}>
              <Col md={12} className='pb-3'>
                <Accordion
                  defaultExpanded={expenseIndex === 0}
                  expanded={hasAccordionError ? true : undefined}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={`emiAccordianSummary${hasAccordionError ? " errorAccordion" : ""}`}
                  >
                    <Typography
                      component={"span"}
                      className='w-100 d-flex align-items-center'
                    >
                      {expense.new ? (
                        <>
                          <TextFieldComponent
                            id='name'
                            type='text'
                            className='noMargin'
                            handleChange={(e) =>
                              this.handleCollectionTypeChange(
                                e,
                                expenseIndex
                              )
                            }
                            value={expense.expenseType ?? ""}
                            disabled={props.readOnly}
                          />
                          {!props.readOnly && (
                            <i
                              className='fa fa-trash ms-2 cursorPointer'
                              aria-hidden='true'
                              title={Strings("Delete")}
                              onClick={(e) =>
                                this.requestDeleteAccordion(e, expenseIndex)
                              }
                            />
                          )}
                        </>
                      ) : (
                        Strings(expense.expenseType)
                      )}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Col md={12} className='pb-3'>
                      {hasAccordionError && (
                        <div className='errors collectionExpenseAccordionError'>
                          <span>{accordionError.message}</span>
                        </div>
                      )}
                      {state.dataForTable && (
                        <EditableDataTable
                          data={{
                            DEFAULT_ROW: state.dataForTable.DEFAULT_ROW,
                            columns: state.dataForTable.columns,
                            dataRows: expense?.amountRange || [],
                          }}
                          rowDelete={!props.readOnly}
                          rowAdd={!props.readOnly}
                          onRowDataChange={(dataRow, indexRow) => {
                            this.handleRowChange(
                              dataRow,
                              indexRow,
                              expenseIndex
                            );
                          }}
                          type={props.type}
                          index={expenseIndex}
                          errorRows={accordionError?.rowErrors || {}}
                        />
                      )}
                    </Col>
                  </AccordionDetails>
                </Accordion>
              </Col>
            </Row>
          );
        })}

        {!props.readOnly && (
          <span onClick={this.handleAddNew} style={{ marginLeft: 12 }}>
            <i>
              <img src={addSubType} alt='add record' />
            </i>
          </span>
        )}
      </div>
    );
  }
}

export default CollectionExpenseConfiguration;
